import { ModelBase, NeoModel } from "@singularsystems/neo-core";

@NeoModel
export default class StaticExportFileSpecPartialLookup extends ModelBase {

    public staticExportFileSpecId: number = 0;

    public reportSpecId: number = 0;

    public reportSpecName: string = "";

    public reportProcedureName: string = "";

    public format: string = "";

    public isExpanded: boolean = false;

    public fileSpecPropertiesConcatenated: string = "";

    public columnCount: number = 0;
}